import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderTextWithConditionalTooltip = ({
    schemaItem,
    item,
    columnKey,
    translate,
}: TableCellProps) => {
    // Error check for undefined item or columnKey
    if (!item[columnKey] || !columnKey) {
        return <td class={schemaItem?.className || ""}>Error: Missing data</td>;
    }
    const translationKey = `${columnKey}.values.${item[columnKey]}`;
    const translated = translate(translationKey);
    const multipleItems =
        typeof item[columnKey] !== "string" && item[columnKey].length > 1;
    return (
        <td class={schemaItem.className} data-testid={columnKey}>
            {!multipleItems &&
                (translated !== translationKey ? translated : item[columnKey])}
            {multipleItems && (
                <div class="ux-u-d-flex ux-u-flex-ai-center">
                    {translate(`${columnKey}.multipleMachines.label`)}
                    <ux-icon name="info" class="ux-u-ml-xxxs"></ux-icon>
                    <ux-tooltip
                        tooltip-target="ux-icon[name='info']"
                        align="top"
                    >
                        <p class="ux-text-normal ux-u-my-zero">
                            {translate(
                                `${columnKey}.multipleMachines.tooltipContent`
                            )}
                        </p>
                        <br />
                        {item[columnKey].map((num) => (
                            <p class="ux-text-normal ux-u-my-zero">{num}</p>
                        ))}
                    </ux-tooltip>
                </div>
            )}
        </td>
    );
};
